import styled from "styled-components";

const AuditVideoContainer = styled.div`
  width: 960px;
  float: left;
`;

export default AuditVideoContainer;
